import { GlobalStatus, SaleStatusEnum, SoStatusEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { InvoiceItems } from "./invoice-items.entity";

@Entity('invoice')
export class Invoice {

  @PrimaryGeneratedColumn("increment", { name: 'invoice_id' })
  invoiceId: number;

  @Column("int", {
    nullable: false,
    name: "sale_order_id"
  })
  saleOrderId: number;

  @Column("varchar", {
    nullable: false,
    name: "invoice_number"
  })
  invoiceNumber: string;

  @Column("date", {
    nullable: false,
    name: "invoice_date"
  })
  invoiceDate: Date;

  @Column("int", {
    nullable: false,
    name: "exporter_id"
  })
  exporterId: number;

  @Column("int", {
    nullable: false,
    name: "importer_id"
  })
  unitId: number;

  @Column("int", {
    nullable: false,
    name: "customer_id"
  })
  customerId: number;

  @Column("int", {
    nullable: false,
    name: "end_customer_id"
  })
  endCustomerId: number;

  @Column("varchar", {
    nullable: false,
    name: "flight_number"
  })
  flightNumber: string;

  @Column({
    type: 'enum',
    nullable: false,
    enum: SoStatusEnum,
    default: SoStatusEnum.OPEN,
    name: "status"
  })
  status: string;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @OneToMany(type => InvoiceItems, invItems => invItems.invoiceInfo, { cascade: true })
  invoiceItemsInfo: InvoiceItems[];

  
}
